import { useLocation } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/Authcontext";



const MarqueeBottom = () => {
  const { themeColors } = useTheme();
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);
  return (
    <>
      <div>
        <section className="footer footer-login">
          <div className="footer-top">
            <div className="footer-links">
              <nav className="navbar navbar-expand-sm py-0" style={{ backgroundColor: themeColors['--bg-primary'] }}>
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <a className="nav-link" href="/termsCondition" target="_blank" data-discover="true">Terms and Conditions</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/responsibleGaming" target="_blank" data-discover="true">Responsible Gaming</a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="support-detail">
              <h3 className="mt-2 fs-4 fw-bold">24X7 Support</h3>
            </div>
            <div className="social-icons-box mt-0">
              {isAuthenticated && (
                <div className="social-icon">
                <a href="#" target="_blank">
                  <img src="/assets/paneal_images/whatsapp-icon.webp" alt="WhatsApp"/>
                </a>
              </div>
              )}
            </div>
          </div>
        </section>

        {location.pathname !== '/login' && (
          <>
            <div className="footer-bottom pb-0">
              <div className="secure-logo">
                <div>
                  <img src="https://wver.sprintstaticdata.com/v3/static/front/img/ssl.png" />
                </div>
                <div className="ml-2" style={{ color: themeColors['--text-body'], fontSize: isLargeScreen ? "16px" : "12px" }}>
                  <b className="fw-bold">100% SAFE</b>
                  <div>Protected connection and encrypted data.</div>
                </div>
              </div>
              <div className="d-inline-block">
                <button className="btn p-0">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/18plus.png" />
                </button>
                <a href="https://www.gamcare.org.uk/" target="_blank">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/gamecare.png" />
                </a>
                <a href="https://www.gamblingtherapy.org/" target="_blank">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/gt.png" />
                </a>
              </div>
            </div>
            <div className="footer-text">
              <p className="text-center mb-0" style={{ color: themeColors['--text-body'], fontSize: isLargeScreen ? "13px" : "12px" }}>© Copyright 2024. All Rights Reserved. Powered by DIAMONDEXCH99.</p>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default MarqueeBottom;
